import { Typography, Link } from "@mui/material";
import React from "react";

interface BreadcrumbItem {
    label: string;
    href: string;
}

interface BreadcrumbsProps {
    breadcrumbs: BreadcrumbItem[];
}

export default function Breadcrumbs({ breadcrumbs }: BreadcrumbsProps) {
    return (
        <Typography
            sx={{
                mb: 2,
                fontFamily: "'Rubik', sans-serif",
                fontSize: "12px",
                fontWeight: 300,
                color: "#010101",
            }}
        >
            {breadcrumbs.map((crumb, index) => (
                <React.Fragment key={index}>
                    <Link
                        href={crumb.href}
                        color="inherit"
                        sx={{
                            textDecoration: "none",
                            transition: "color 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                            "&:hover": {
                                color: "#9e9e9e",
                            },
                        }}
                    >
                        {crumb.label}
                    </Link>
                    {index < breadcrumbs.length - 1 && " > "}
                </React.Fragment>
            ))}
        </Typography>
    );
}
